import { useMemo } from 'react';
import styles from './FilesList.module.css';

const FilesList = (props) => {
    const { fileHelpers } = props;
    const { filesToDisplay, onFileNameChange, onDeleteFile } = fileHelpers;

    const isLoading = useMemo(() => filesToDisplay.every(file => !file.url.startsWith('blob:')) ? false : true, [filesToDisplay]);

    return (
        <div className={styles.fileListColumn}>
            {filesToDisplay.map((file) => (
                <div key={file.id} className={styles.fileItem}>
                    <div className={`${styles.previewWrapper} ${(isLoading && file.url.startsWith('blob:')) && styles.loadingWrapper}`} onClick={() => !file.url.startsWith('blob:') && window.open(file.url, '_blank')} > 
                        {(isLoading && file.url.startsWith('blob:')) &&
                            <div className={styles.loadingOverlay}>
                                <div className={styles.spinner}></div>
                            </div>
                        }
                        {(file.url.includes('.pdf') || (file?.file && file.file?.type === 'application/pdf')) ?
                            <i className={`fa-regular fa-file-pdf ${styles.preview}`} />
                        :
                            <img src={file.url} className={styles.preview}></img>
                        }
                    </div>
                    <input
                        type='text'
                        value={file.name}
                        onChange={(e) => onFileNameChange(file.id, e.target.value)}
                        className={styles.fileNameInput}
                        aria-label={`Edit name for ${file.name}`}
                    />
                    <button
                        onClick={() => onDeleteFile(file.id)}
                        className={styles.deleteFileBtn}
                        title={`Delete ${file.name}`}
                        aria-label={`Delete ${file.name}`}
                    >
                        <i className='far fa-trash-alt'></i>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default FilesList;